import { List, rows, Tabs, Filters } from "colbi_web_ui/lib/components";
import theme from "colbi_web_ui/lib/style/_theme.json";
import { StackLayout } from "../layouts";
import PackagesAssociation from "../controllers/Settings/PackagesAssociation";
import { parseFilter } from "colbi_web_ui/lib/utils";
import UserActions from "../actions/UserActions/UserActions";

const tabs = [
    { entity: "package_rules", model: "package_rules" },
    { entity: "package_kpis", model: "package_kpis" },
    { entity: "package_custom_reports", model: "package_custom_reports" },
];

const queries = (args = {}) => [
    {
        resource: args.entity,
        args: {
            packageId: +args.id,
            locale: args.locale,
            filter: args.filter
                ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                : undefined,
            sort: args.sort ? { type: "[SortInput!]", value: parseFilter(args.sort) } : undefined,
        },
        body: `__typename, hasMore, items{...${args.entity}}, filters{ prop, name, type, list, disableOperators, mandatory }`,
        downloadable: false,
        xlsxTranslation: args.entity,
    },
];

const packageAssociation = (path, navigation, exact, title, navByImportId = false) => ({
    path,
    navigation,
    component: PackagesAssociation,
    exact,
    navByImportId,
    queries,
    title: [title],
    components: [
        {
            component: Filters,
            props: {
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                stickyTop: parseInt(theme.layout.$headerHeight, 10),
                anchor: "results",
            },
        },
        {
            component: Tabs,
            modifiers: ["--root-margin-top-small", "--root-margin-bottom-small"],
            props: {
                basePath: `${path}`,
                showCount: false,
                data: tabs,
                labelKey: "entity",
                routeKey: "model",
                preserveEmptyTabs: true,
                preserveFilters: ["ID"],
                redirectEnabler: true,
                stickyTop: 0,
            },
        },
    ],
    routes: [
        {
            path,
            exact: true,
            queries,
            component: StackLayout,
            components: [
                {
                    component: List,
                    modifiers: ["--root-margin-top-small", "--row-style-alternate"],
                    props: {
                        renderOnChangeTab: true,
                        checkbox: true,
                        headerListComponent: [
                            {
                                component: UserActions,
                            },
                        ],
                        id: "results",
                        items: "query(0).list",
                        filter: "param(filter)",
                        sort: "param(sort)",
                        card: rows.EntityCard,
                        metadata: "query(0).metadata",
                        page: "param(page)",
                        status: "status(0)",
                        pageSize: "param(pageSize)",
                        pageDefault: 10,
                        header: "query(0).header",
                    },
                },
            ],
        },
    ],
});

export default packageAssociation;
